import { render } from "./AboutCompanyTab.vue?vue&type=template&id=7e7458ae&ts=true"
import script from "./AboutCompanyTab.vue?vue&type=script&lang=ts"
export * from "./AboutCompanyTab.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__